import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { BaseAdminScreen, AdminEmptyScreenLayout, SearchBar, KeyboardSafeView } from '@/components';
import { FeatureFlagsList, FeatureFlagsDetailsSidebar, DesktopFeatureFlagsView } from '@/components/admin/featureFlags';
import { FeatureFlagAttributes } from '@/types/admin/featureFlags';
import { AdminErrorBoundary } from '@/components/common/admin/mobile/AdminErrorBoundary';
import { useResponsive } from '@/hooks/common/useResponsive';

interface FeatureFlagsScreenProps {
  navigation?: any;
}

export const FeatureFlagsScreen: React.FC<FeatureFlagsScreenProps> = ({
  navigation,
}) => {
  const { layoutMode } = useResponsive();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRow, setSelectedRow] = useState<FeatureFlagAttributes | null>(null);
  const [isOrganizationView, setIsOrganizationView] = useState(false);

  const handleSelectRow = (flag: FeatureFlagAttributes, isOrgView: boolean) => {
    setSelectedRow(flag);
    setIsOrganizationView(isOrgView);
  };

  // Desktop layout
  if (layoutMode === 'desktop') {
    return (
      <AdminErrorBoundary context="FeatureFlagsScreenDesktop">
        <DesktopFeatureFlagsView />
      </AdminErrorBoundary>
    );
  }

  // Mobile layout
  return (
    <AdminErrorBoundary context="FeatureFlagsScreen">
      <BaseAdminScreen
        screenName="FeatureFlags"
        navigation={navigation}
        showPlaceholder={false}
        scrollEnabled={false}
        contentContainerStyle={styles.baseScreenContent}
      >
        <AdminEmptyScreenLayout
          title="Feature Flags"
          emptyStateType="property"
          showAddButton={false}
          hasContent={true}
          disableScrollView={true}
        >
          <KeyboardSafeView>
            <View style={styles.container}>
              <View style={styles.searchContainer}>
                <SearchBar
                  placeholder="Search flags..."
                  value={searchTerm}
                  onChangeText={setSearchTerm}
                  style={styles.searchBar}
                />
              </View>

              <FeatureFlagsList
                searchTerm={searchTerm}
                onSelectRow={handleSelectRow}
              />

              <FeatureFlagsDetailsSidebar
                selectedFeatureFlag={selectedRow || undefined}
                onClose={() => setSelectedRow(null)}
                isOrganizationView={isOrganizationView}
              />
            </View>
          </KeyboardSafeView>
        </AdminEmptyScreenLayout>
      </BaseAdminScreen>
    </AdminErrorBoundary>
  );
};

const styles = StyleSheet.create({
  baseScreenContent: {
    paddingHorizontal: 0,
    paddingTop: 0,
    paddingBottom: 0,
    flexGrow: 1,
  },
  container: {
    flex: 1,
  },
  searchContainer: {
    paddingHorizontal: 2,
    paddingTop: 16,
    paddingBottom: 12,
  },
  searchBar: {
    // SearchBar component already has internal padding and styling
  },
});
